import { render, staticRenderFns } from "./grinding-load-edit-form.html?vue&type=template&id=e2673442&scoped=true&"
import script from "./grinding-load-edit-form.ts?vue&type=script&lang=js&"
export * from "./grinding-load-edit-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2673442",
  null
  
)

export default component.exports